import { OFFER_REFERENCE_PREFIX } from '../config/constants';

export const generateOfferReference = (existingReferences: string[]): string => {
  const year = new Date().getFullYear();
  const prefix = `${OFFER_REFERENCE_PREFIX}-${year}`;
  const currentValues = existingReferences
    .filter((reference) => reference.startsWith(prefix))
    .map((reference) => {
      const parts = reference.split('-');
      return Number(parts[parts.length - 1] ?? '0');
    });

  const nextValue = (Math.max(0, ...currentValues) + 1).toString().padStart(4, '0');
  return `${prefix}-${nextValue}`;
};
